import { FC } from 'react'

import { AsyncMultiSelectControl } from '@sequencehq/core-components'

import { useCustomerPaginatedFetcher } from 'Customer/hooks/useCustomerPaginatedFetcher'

/**
 * Search-driven, paginated multi-select customer picker. Mirrors the single
 * `CustomerSelect`: customers are fetched on demand via the shared paginated
 * fetcher (with an initial page) and the selection is search-led rather than
 * loading every customer up front. Exported from the Customer module so other
 * modules can reuse it.
 */
export const CustomerMultiSelect: FC<{
  'data-testid'?: string
  values: string[]
  onChange: (value: string[]) => void
  isInvalid?: boolean
  /** When true, the picker auto-opens on mount. */
  initiallyOpen?: boolean
}> = ({
  'data-testid': dataTestId,
  values,
  onChange,
  isInvalid = false,
  initiallyOpen
}) => {
  const { paginatedFetcher, mapToOption, resolveValues } =
    useCustomerPaginatedFetcher()

  return (
    <AsyncMultiSelectControl
      data-testid={dataTestId}
      entityName="customer"
      value={values}
      onChange={onChange}
      paginatedFetcher={paginatedFetcher}
      mapToOption={mapToOption}
      resolveValue={resolveValues}
      placeholder="Search for a customer"
      isInvalid={isInvalid}
      initiallyOpen={initiallyOpen}
    />
  )
}
